import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
    meta: { transition: 'slide-left' }
  },
  {
    path: '/account',
    name: 'account',
    component: () => import('../views/AccountView.vue'),
    meta: { transition: 'slide-right' }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/ProfileView.vue'),
    meta: { transition: 'slide-right', requiresAuth: true }
  },
  {
    path: '/artist/:artistId',
    name: 'artist',
    component: () => import('../views/ArtistView.vue'),
    meta: { transition: 'slide-right' }
  },
  {
    path: '/collab',
    name: 'collab',
    component: () => import('../views/CollabView.vue'),
    meta: { transition: 'slide-right' }
  },
  {
    path: '/beats',
    name: 'beats',
    component: () => import('../views/BeatView.vue'),
    meta: { transition: 'slide-right' }
  },
  {
    path: '/mix',
    name: 'mix',
    component: () => import('../views/MixView.vue'),
    meta: { transition: 'slide-right' }
  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import('../views/ClientProjectsView.vue'),
    meta: { transition: 'slide-right', requiresAuth: true }
  },
  {
    path: '/engineer/jobs',
    name: 'engineer-jobs',
    component: () => import('../views/EngineerJobsView.vue'),
    meta: { transition: 'slide-right', requiresAuth: true }
  },
  {
    path: '/auth/verify-email',
    name: 'verify-email',
    component: () => import('../views/VerifyEmailView.vue')
  },
  {
    path: '/auth/reset-password',
    name: 'reset-password',
    component: () => import('../views/ResetPasswordView.vue')
  },
  {
    path: '/payment/callback',
    name: 'payment-callback',
    component: () => import('../views/PaymentCallbackView.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/AdminView.vue'),
    meta: { transition: 'slide-right', requiresAuth: true }
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('../views/DownloadView.vue')
  },
  {
    path: '/beats/favourites',
    name: 'favourites',
    component: () => import('../views/FavouritesView.vue'),
    meta: { transition: 'slide-right', requiresAuth: true }
  },
  {
    path: '/engineer/beats',
    name: 'engineer-beats',
    component: () => import('../views/EngineerBeatsView.vue'),
    meta: { transition: 'slide-right', requiresAuth: true }
  },
  {
    path: '/songs/:id',
    name: 'song-detail',
    component: () => import('../views/SongDetailView.vue'),
    meta: { transition: 'slide-right' }
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('../views/TermsView.vue'),
    meta: { transition: 'slide-right' }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/PrivacyView.vue'),
    meta: { transition: 'slide-right' }
  },
  {
    path: '/data-deletion',
    name: 'data-deletion',
    component: () => import('../views/DataDeletionView.vue'),
    meta: { transition: 'slide-right' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ selector: to.hash, offset: { x: 0, y: 80 }, behavior: 'smooth' })
        }, 500)
      })
    } else {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ el: '#main', left: 0, top: 10, behavior: 'smooth' })
        }, 500)
      })
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.user) {
      next({ path: '/account' })
    } else {
      next()
    }
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  const toDepth = to.path.split('/').length
  const fromDepth = from.path.split('/').length
  to.meta.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
})

export default router
